import { Image, ImageFit, Stack, useTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { getAepPayloadContentType } from "../../../externalApi/AepApi";
import { requestRefresh } from "../../../externalApi/DashboardHostApi";
import { addVisibilityEventListeners, getIsWindowVisible, getLastShowReason, removeVisibilityEventListeners } from "../../../externalApi/WindowApi";
import { getResources } from "../../../getResources";
import { Button } from "../../generic/Button/Button";
import { getWideDefaultButtonStyle } from "../../generic/Button/Button.styles";
import { Grid } from "../../generic/Grid/Grid";
import { Text } from "../../generic/Text/Text";
import { getContainerStyle, getGlobalOfflineImageStyle } from "./GlobalOfflinePage.styles";
import { logPageEvent, logPageHidden, logPageShown } from "../Telemetry/PageTelemetry";
const GlobalOfflinePage = (props) => {
    const handleWindowShown = async () => {
        const [aepPayloadContentType, lastShowReason] = await Promise.all([
            getAepPayloadContentType(),
            getLastShowReason(),
        ]);
        logPageShown("global-offline", aepPayloadContentType, lastShowReason);
    };
    const handleWindowHidden = () => {
        logPageHidden("global-offline");
    };
    useEffect(() => {
        logPageEvent("global-offline");
        addVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        // If the Window is visible fire the visibility event since we will have missed the first on on cold launch.
        getIsWindowVisible().then((visible) => {
            if (visible) {
                handleWindowShown();
            }
        }, (reason) => {
            // If windowAPI is unavailable do nothing
        });
        return () => {
            removeVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        };
    }, []);
    const theme = useTheme();
    const offlineImageProps = {
        imageFit: ImageFit.contain,
        src: theme.customImages.globalOfflineImage,
    };
    const ariaLabel = getResources().GlobalOfflinePage_OfflineErrorMessage + " " + getResources().GlobalOfflinePage_OfflineErrorSubtext;
    return (React.createElement("div", { onClick: (e) => { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, style: { height: "100%" } },
        React.createElement(Stack, { id: "global-offline-page", "aria-label": ariaLabel, horizontalAlign: "center", verticalAlign: "center", styles: getContainerStyle() },
            React.createElement(Image, Object.assign({}, offlineImageProps, { id: "offline-logo", alt: "", styles: getGlobalOfflineImageStyle() })),
            React.createElement(Text, { variant: "xxLarge", marginBottom: "12px", role: "heading", "aria-level": "1" }, getResources().GlobalOfflinePage_OfflineErrorMessage),
            React.createElement(Text, { variant: "medium", marginBottom: "28px" }, getResources().GlobalOfflinePage_OfflineErrorSubtext),
            React.createElement(Grid, { tokens: { childrenGap: 15, columns: 2 } },
                React.createElement(Button, { id: "refresh-button", onClick: () => requestRefresh(), styles: getWideDefaultButtonStyle() }, getResources().GlobalOfflinePage_ReloadButtonText),
                React.createElement(Button, { id: "network-settings-button", primary: true, href: "ms-settings:network", styles: getWideDefaultButtonStyle() }, getResources().GlobalOfflinePage_CheckConnectionButtonText)))));
};
export default GlobalOfflinePage;
